import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';
import { FiltersFormPec } from 'shell/types/types-pec';

export const initialValuesManagementPecSearch: FiltersFormPec = {
  emailReceiver: '',
  emailSender: '',
  endDate: null,
  oggetto: '',
  orders: {},
  page: undefined,
  rowsPerPage: undefined,
  startDate: null,
  state: '',
  typeComunication: '',
};

const ManagementPecPageSearchInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesManagementPecSearch}>
      <Outlet />
    </FilterTableProvider>
  );
};

ManagementPecPageSearchInitializer.displayName = 'Management Pec Page Search initializer component';

export default ManagementPecPageSearchInitializer;
